import React from "react";

import {Route, Routes} from "react-router-dom";
import Activity from "./activity";
import OAuthInit from "./oauth/Init";
import GraphQLProvider from "../graphql/GraphQLProvider";
import OAuthCallback from "./oauth/Callback";
import Provider from "./oauth/Provider";

export default function Calls() {

    return <GraphQLProvider>
        <Provider>
            <Routes>
                <Route path=":integration" element={<Activity />} />
                <Route path=":integration/oauth/init" element={<OAuthInit />} />
                <Route path=":integration/oauth/callback" element={<OAuthCallback />} />
            </Routes>
        </Provider>
    </GraphQLProvider>

}
